import * as types from 'store/types';
import { update } from 'variables/utilities';

const initial = {
  request: null,
	loading: false
};

const started = (state, action) => {
	return update( state, {
		request: action.request,
		error: null, loading: true
	});
};

const succeeded = (state, action) => {
	const templates = action.templates ? action.templates : state.templates;
	if(action.template) {
		templates.map((template, index) => {
			if(template.templateId === action.template.templateId) {
				templates[index] = action.template;
			}
			return null;
		});
	}
	const template = action.template ? action.template : state.template;
	return update( state, {
		templates: templates,
    template: action.templates ? undefined : template,
		loading: false, modifiedDate: new Date(),
	});
};

const failed = (state, action) => {
	return update( state, {
			error: action.error, loading: false
	});
}

const businesses = (state = initial, action) => {
	switch ( action.type ) {
		case types.TEMPLATE_START: 
			return started(state, action);

		case types.TEMPLATE_SUCCESS: 
			return succeeded(state, action);

		case types.TEMPLATE_FAILURE: 
			return failed(state, action);

		default:
			return state;
	}
};

export default businesses;